/* eslint-disable sort-keys */
/* eslint sort-keys: ["error", "asc", {natural: true, caseSensitive: false}] */
const errorMessage = {
  notFoundProjectInFp: 'The specified project was not found (FP)',
  validation: 'Input value is invalid: {0}',
};

export const messagesInEn = {
  // 共通仕様: その他例外
  '/error/global/0000': 'An unknown error has occurred',
  '/error/global/0001': 'Your access token has expired',
  '/error/global/0002': 'An unknown server error occurred',
  '/error/global/0003': 'The project cannot be found.  Please contact the administrator.If necessary, please contact the Taisei IT Help Desk (s-net@pub.taisei.co.jp).',
  '/error/global/0004': 'There is no project invitation information.  Please contact the administrator.If necessary, please contact the Taisei IT Help Desk (s-net@pub.taisei.co.jp).',
  '/error/global/0005': 'This project has been deleted.  Please contact the administrator.If necessary, please contact the Taisei IT Help Desk (s-net@pub.taisei.co.jp).',
  '/error/global/0006': 'There are no projects that can be displayed. Please contact the administrator.If necessary, please contact the Taisei IT Help Desk (s-net@pub.taisei.co.jp).',
  '/error/global/0007': 'This project(service) has been deleted.  Please contact the administrator.If necessary, please contact the Taisei IT Help Desk (s-net@pub.taisei.co.jp).',
  '/error/global/0008': 'This project(service) has been closed.  Please contact the administrator.If necessary, please contact the Taisei IT Help Desk (s-net@pub.taisei.co.jp).',
  // [図面API](002001) Myショートカット検索
  '/error/S-CAPI-DDMS-002001/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-002001/1001': errorMessage.notFoundProjectInFp,
  // (001001) プロジェクト情報一覧
  '/error/S-CAPI-FP-001001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001001/0002': errorMessage.notFoundProjectInFp,
  // (001002) デフォルトプロジェクト取得
  '/error/S-CAPI-FP-001002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001002/0002': 'You can switch project to you want to view.',
  '/error/S-CAPI-FP-001002/0003': 'There is no project invitation information.',
  '/error/S-CAPI-FP-001002/0004': 'There are no projects that can be displayed.',
  '/error/S-CAPI-FP-001002/0005': 'The Project is in service preparation.',
  // (001003) デフォルトプロジェクト更新
  '/error/S-CAPI-FP-001003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001003/0002': errorMessage.notFoundProjectInFp,
  // (001004) プロジェクト詳細取得
  '/error/S-CAPI-FP-001004/0001': errorMessage.validation,
  // (001005) プロジェクト招待者取得
  '/error/S-CAPI-FP-001005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001005/0002': errorMessage.notFoundProjectInFp,
  // (001006) プロジェクト情報取得
  '/error/S-CAPI-FP-001006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001006/0002': errorMessage.notFoundProjectInFp,
  // (001008) 役割追加更新
  '/error/S-CAPI-FP-001008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001008/0002': errorMessage.notFoundProjectInFp,
  // (001009) 未使用役割一覧取得
  '/error/S-CAPI-FP-001009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-001009/0002': errorMessage.notFoundProjectInFp,
  // (002002) レイアウト更新
  '/error/S-CAPI-FP-002002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002002/0004': 'The specified layout is not found',
  // (002004) レイアウト追加
  '/error/S-CAPI-FP-002004/0001': errorMessage.validation,
  // (002005) レイアウト一覧取得
  '/error/S-CAPI-FP-002005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002005/0002': 'There are no layouts visible in this project. please contact the Taisei IT Help Desk (s-net@pub.taisei.co.jp).',
  // (002006) デフォルトレイアウト取得
  '/error/S-CAPI-FP-002006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002006/0002': errorMessage.notFoundProjectInFp,
  // (002007) デフォルトレイアウト更新
  '/error/S-CAPI-FP-002007/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002007/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002007/0003': 'The specified layout is not found',
  // (002008) 管理者用レイアウト一覧取得
  '/error/S-CAPI-FP-002008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002008/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-002008/0003': 'You do not have permission to edit the administrator layout',
  // (002009) レイアウト名変更
  '/error/S-CAPI-FP-002009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002009/0002': errorMessage.notFoundProjectInFp,
  // (002010) レイアウト削除
  '/error/S-CAPI-FP-002010/0001': errorMessage.validation,
  '/error/S-CAPI-FP-002010/0002': errorMessage.notFoundProjectInFp,
  // (004001) メインメニュー詳細取得
  '/error/S-CAPI-FP-004001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-004001/0002': errorMessage.notFoundProjectInFp,
  // (004003) 管理者用メインメニュー詳細取得
  '/error/S-CAPI-FP-004003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-004003/0002': 'You do not have permission to edit the main menu for administrators',
  // (005001) ダウンロード履歴検索結果取得
  '/error/S-CAPI-FP-005001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005001/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005001/0003': 'Cannot find the data source (API) to retrieve the download history',
  // (005002) 新着通知検索結果取得
  '/error/S-CAPI-FP-005002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005002/0003': 'Cannot find the data source (API) to retrieve the new information',
  // (005003) 保存済み検索条件詳細取得
  '/error/S-CAPI-FP-005003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005003/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005003/0003': 'The specified search condition was not found',
  // (005004) 新着通知既読更新
  '/error/S-CAPI-FP-005004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-005004/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-005004/0003': 'I couldn\'t get it to read',
  // (006001) 保存済み検索条件一覧取得
  '/error/S-CAPI-FP-006001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006001/0002': errorMessage.notFoundProjectInFp,
  // (006002) 保存済み検索条件取得
  '/error/S-CAPI-FP-006002/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006002/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-006002/0003': 'The specified search condition was not found',
  // (006004) 保存済み検索条件追加更新
  '/error/S-CAPI-FP-006004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006004/0002': errorMessage.notFoundProjectInFp,
  // (006005) 保存済み検索条件削除
  '/error/S-CAPI-FP-006005/0001': errorMessage.validation,
  '/error/S-CAPI-FP-006005/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-006005/0003': 'The specified search condition was not found',
  '/error/S-CAPI-FP-006005/0004': 'The specified search condition cannot be deleted because it is already used in the gadget',
  // (007001) 拡張属性定義一覧取得
  '/error/S-CAPI-FP-007001/0001': errorMessage.validation,
  // (007002) ユーザー拡張属性定義削除
  '/error/S-CAPI-FP-007002/0001': errorMessage.validation,
  // (007003) ユーザー拡張属性定義登録
  '/error/S-CAPI-FP-007003/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007003/0002': 'Failed to register extended attribute definition',
  // (007004) ユーザー拡張属性定義更新
  '/error/S-CAPI-FP-007004/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007004/0002': errorMessage.notFoundProjectInFp,
  '/error/S-CAPI-FP-007004/0003': 'Failed to update extended attribute definition',
  // (007005) 拡張属性定義関連内容タグ一覧取得
  '/error/S-CAPI-FP-007005/0001': errorMessage.validation,
  // (007006) 拡張属性区分値一括登録
  '/error/S-CAPI-FP-007006/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007006/0002': 'Extended attribute definition not found',
  '/error/S-CAPI-FP-007006/0003': 'Failed to register the category value of the extended attribute definition',
  // (007007) 拡張属性区分値一括更新
  '/error/S-CAPI-FP-007007/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007007/0002': 'Extended attribute definition not found',
  '/error/S-CAPI-FP-007007/0003': 'Classification value to be updated is not found',
  '/error/S-CAPI-FP-007007/0004': 'Failed to update the classification value of the extended attribute definition',
  // (007008) 拡張属性定義関連内容タグ一括更新
  '/error/S-CAPI-FP-007008/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007008/0002': 'Failed to update extended attribute definition related content tag',
  // (007009) 拡張属性区分値削除
  '/error/S-CAPI-FP-007009/0001': errorMessage.validation,
  '/error/S-CAPI-FP-007009/0002': 'Extended attribute definition not found',
  '/error/S-CAPI-FP-007009/0003': 'Classification value to be updated is not found',
  '/error/S-CAPI-FP-007009/0004': 'Failed to delete the category value of the extended attribute definition',
  // (008001) 内容タグツリー取得
  '/error/S-CAPI-FP-008001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-008002/0001': 'You do not have access rights to the specified project',
  // (009001) ラック検索
  '/error/S-CAPI-FP-009001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-009001/0002': 'The extended attribute is incorrect',
  // (010001) 内容タグViewパターン一覧取得
  '/error/S-CAPI-FP-010001/0001': errorMessage.validation,
  '/error/S-CAPI-FP-010001/0002': errorMessage.notFoundProjectInFp,
  // (011001) データラック一覧取得
  '/error/S-CAPI-DDMS-051001/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-051001/0002': errorMessage.validation,
  // (011001) ファイルダウンロード(購読制御入り)
  '/error/S-CAPI-DDMS-010003/0001': errorMessage.validation,
  '/error/S-CAPI-DDMS-010003/0002': errorMessage.validation,
  'dataRackSearch.error': '{0} get information failed.',
  '/error/S-CAPI-DDMS-010003/0006': 'new arrival notification not found',
  'addSearchCriteriaButton.label': 'Add Search Criteria',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.READ': 'Read',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.READ_WRITE': 'Write',
  'ContentTagRoleAccessPermissionModelAccessTypeEnum.undefined': 'Undefined',
  'DataBoxModelApprovalTypeEnum.APPROVED': 'Approved',
  'DataBoxModelApprovalTypeEnum.APPROVING': 'Approving',
  'DataBoxModelApprovalTypeEnum.DENIAL': 'Denial',
  'DataBoxModelApprovalTypeEnum.PARTIAL_APPROVAL': 'Partial Approval',
  'DataBoxModelApprovalTypeEnum.UNAPPROVED': 'Unapproved',
  'DataBoxModelApprovalTypeEnum.undefined': 'Undefined Type',
  'dialog.apply': 'Apply',
  'dialog.cancel': 'Cancel',
  'dialog.close': 'Close',
  'dialog.delete.message': 'Please note that if you delete it, you cannot restore it.',
  'dialog.delete.title': 'Do you really want to delete this?',
  'dialog.editAttributeValueName.label.name': 'Display Name',
  'dialog.editGadgetImage.label.color': 'Background Color',
  'dialog.editGadgetImage.label.image': 'Image URL',
  'dialog.editGadgetImage.message': 'Specify the URL of the background image of the selected gadget.',
  'dialog.editGadgetImage.title': 'Apply a background image',
  'dialog.editGadgetName.title': 'Edit the display name of the gadget',
  'dialog.layoutAdd.description': 'Please enter the layout name.',
  'dialog.layoutAdd.title': 'Add layout',
  'dialog.layoutEdit.message.confirm': 'Are you sure you want to lose the information you have entered?',
  'dialog.layoutEdit.message.leave': 'I\'m trying to navigate the page.',
  'dialog.layoutEdit.title': 'Breakaway Confirmation',
  'dialog.layoutEditChange.message.change': 'Trying to switch the layout.',
  'dialog.layoutEditChange.message.confirm': 'Are you sure you want to lose the information you have entered?',
  'dialog.layoutEditChange.title': 'Confirmation of layout switching',
  'dialog.layoutNameEdit.description': 'Please enter the layout name.',
  'dialog.layoutNameEdit.title': 'Change the layout name',
  'dialog.leaveLayoutEdit.message': 'Are you sure you want to save the content you are currently editing and go to the file search screen?',
  'dialog.leaveLayoutEdit.title': 'Go to the file search screen.',
  'dialog.ok': 'OK',
  'dialog.roleAdd.message': 'Enter the role code and role name.',
  'dialog.roleAdd.note': 'If the role code already exists, it will be overwritten.',
  'dialog.roleAdd.title': 'Add Role',
  'dialog.roleChanger.title': 'Layout Role Change',
  'dialog.roleChanger.unusedRole': 'Unused Roles',
  'downloadHistory.contentTagName': 'Folder Name',
  'downloadHistory.dataRackName': 'File Name',
  'downloadHistory.downloadAt': 'Downloaded At',
  'extensiveAttribute.availableFlag': 'Available',
  'extensiveAttribute.commonManagementFlag': 'Type',
  'extensiveAttribute.contentTags': 'Extensive Attribute Folder',
  'extensiveAttribute.extensiveAttributeDefinition': 'Extensive Attribute Definition',
  'extensiveAttribute.extensiveAttributeDefinitionName': 'Extensive Attribute Name',
  'extensiveAttribute.extensiveAttributeValue': 'Value',
  'extensiveAttribute.valueEditAllowFlag': 'Value Editable',
  'extensiveAttribute.valueType': 'Extensive Attribute Type',
  'ExtensiveAttributeModel.availableFlag.label': 'Available',
  'ExtensiveAttributeModel.commonManagementFlag.label': 'Type',
  'ExtensiveAttributeModel.commonManagementFlag.label.COMMON': 'Common',
  'ExtensiveAttributeModel.commonManagementFlag.label.undefined': 'Unknown Type',
  'ExtensiveAttributeModel.commonManagementFlag.label.USER': 'User',
  'ExtensiveAttributeModel.descriptionText.label': 'Description',
  'ExtensiveAttributeModel.extensiveAttributeDefinitionName.label': 'Name',
  'ExtensiveAttributeModel.valueType.label': 'Value Type',
  'ExtensiveAttributeModel.valueType.label.BOOL': 'Boolean',
  'ExtensiveAttributeModel.valueType.label.DATE': 'Date',
  'ExtensiveAttributeModel.valueType.label.DATETIME': 'Datetime',
  'ExtensiveAttributeModel.valueType.label.MULTI_SELECT': 'Multi Select',
  'ExtensiveAttributeModel.valueType.label.NUMBER': 'Number',
  'ExtensiveAttributeModel.valueType.label.SINGLE_SELECT': 'Single Select',
  'ExtensiveAttributeModel.valueType.label.TEXT': 'Text',
  'ExtensiveAttributeModel.valueType.label.WHOLE_NUMBER': 'Whole Number',
  'ExtensiveAttributeModel.valueType.label.undefined': 'Unknown Type',
  'ExtensiveAttributeValueModel.common_management_flag.COMMON': 'Common',
  'ExtensiveAttributeValueModel.common_management_flag.undefined': 'Unknown Type',
  'ExtensiveAttributeValueModel.common_management_flag.USER': 'User',
  'field.displayName.en': 'Display Name (En)',
  'field.displayName.ja': 'Display Name',
  'field.roleCode': 'Role Code',
  'FpCustomColumnMenu.label.save': 'Save',
  'FpDownloadHistoryGrid.message': 'Showing history for the last 90 days',
  'FpExtensiveAttribute.commonManagementFlag.common': 'Common',
  'FpExtensiveAttribute.commonManagementFlag.user': 'User',
  'FpExtensiveAttribute.flag.true': 'Yes',
  'FpExtensiveAttribute.header.edit': 'Edit',
  'FpExtensiveAttribute.header.new': 'New Addition',
  'FpExtensiveAttribute.valueType.bool': 'Bool',
  'FpExtensiveAttribute.valueType.date': 'Date',
  'FpExtensiveAttribute.valueType.datetime': 'Datetime',
  'FpExtensiveAttribute.valueType.multiSelect': 'Multi Select',
  'FpExtensiveAttribute.valueType.number': 'Number',
  'FpExtensiveAttribute.valueType.singleSelect': 'Single Select',
  'FpExtensiveAttribute.valueType.text': 'Text',
  'FpExtensiveAttribute.valueType.wholeNumber': 'Whole Number',
  'FpExtensiveAttributeGrid.filter.hint': 'Filter Extensive Attribute Name',
  'FpExtensiveAttributesAdd.title': 'Extensive Attribute Add',
  'FpExtensiveAttributesContentTagManagement.title': 'Edit Extended Attribute Folder',
  'FpExtensiveAttributesEdit.error': 'Extensive-Attribute that cannot be edited',
  'FpExtensiveAttributesEdit.title': 'Extensive-Attribute Edit',
  'FpExtensiveAttributesFolderSelect.confirm.body': 'Update Extensive-Attribute applied folders?',
  'FpExtensiveAttributesFolderSelect.filter.label': 'Filtering By Folder Name',
  'FpExtensiveAttributesValuesEdit.error': 'Extensive-Attribute-Values that cannot be edited',
  'FpExtensiveAttributesValuesEdit.success': 'Extensive-Attribute-Values Saved',
  'FpExtensiveAttributesValuesEdit.title': 'Extensive-Attribute-Values Edit',
  'FpExtensiveAttributesValuesEdit.warning': 'No change',
  'FpExtensiveAttributeValueDetail.delete.description': 'Please note that if you delete the file, it cannot be restored.',
  'FpExtensiveAttributeValueDetail.delete.title': 'Deletes the selected category value',
  'FpFileSearch.criteria-save-as': 'Save as',
  'FpFileSearch.label.clear': 'clear',
  'FpFileSearch.label.save': 'Save',
  'FpFileSearch.notification.project-not-found': 'search criteria is not for this project.',
  'FpFileSearch.notification.save-criteria.error': 'unknown error occurred when search criteria save.',
  'FpFileSearch.notification.save-criteria.success': 'Successful',
  'FpFileSearch.notification.search.error': 'Error Occurred at file searching.',
  'FpFileSearchCommonCriteria.label.created-at': 'Created At',
  'FpFileSearchCommonCriteria.label.creator': 'Created By',
  'FpFileSearchCommonCriteria.label.file-name': 'File Name',
  'FpFileSearchCriteria.label.back': 'Back',
  'FpFileSearchCriteria.label.clear': 'Clear',
  'FpFileSearchCriteria.label.save': 'Save Search Criteria',
  'FpFileSearchCriteria.label.search': 'Search',
  'FpFileSearchCriteria.label.search-criteria': 'Advanced search',
  'FpFileSearchCriteria.search-criteria-advanced': 'Advanced search (If multiple conditions are specified, they are applied with OR conditions.)',
  'FpFileSearchCriteria.criteria-required': 'Please enter one or more search criteria to search',
  'FpFileSearchResult.header.details.title': 'File Details',
  'FpFileSearchWrapper.criteria.not-found': 'Search-Criteria not found',
  'FpFolderSearch.filter.label': 'Filter By Folder Name',
  'FpFolderSearch.notification.warn.view-pattern-not-found': 'VIEW Pattern not found.',
  'FpGadgetButtonGroup.title': 'Gadgets copied from templates cannot be edited',
  'FpLayoutCopy.destination-list.chip.create': 'New',
  'FpLayoutCopy.destination-list.chip.template': 'Template',
  'FpLayoutCopy.destination-list.selected-project.count': 'projects selected',
  'FpLayoutCopy.destination-type.copied': 'Copy to Normal Project',
  'FpLayoutCopy.destination-type.template': 'Copy to Template Project',
  'FpLayoutCopy.notification.success': 'Layout Copy is completed',
  'FpLayoutCopy.section-title.destinations': 'Select Copy Destination',
  'FpLayoutCopyPreview.preview-type.copied': 'Copy Result',
  'FpLayoutCopyPreview.preview-type.destination': 'Copy Destination',
  'FpLayoutCopyPreview.preview-type.source': 'Copy Source',
  'FpLayoutEdit.role_view.title': 'Headquarters Roles',
  'FpMainMenuEditFileSearch.description': '{0}で使用しているメインメニューを編集します',
  'FpMainMenuEditFileSearch.dialog.title': 'File',
  'FpMainMenuEditFileSearch.label.add': 'add',
  'FpMainMenuEditRoleList.title': 'List of roles that can be displayed',
  'FpMainMenuEditSearchCriteria.title': 'file search',
  'FpMainMenuEditSplitter.custom.label': 'Custom Items',
  'FpMainMenuEditSplitter.etc.file': 'Add File',
  'FpMainMenuEditSplitter.etc.folder': 'Add Folder',
  'FpMainMenuEditSplitter.etc.label': 'Others',
  'FpMainMenuEditSplitter.normal.label': 'Basic Items',
  'FpMainMenuEditSplitter.normal.subTitle': 'Subheading',
  'FpMainMenuEditSplitter.normal.text': 'Text',
  'FpMainMenuEditSplitter.normal.url': 'URL',
  'FpMainMenuItemAddAction.button': 'Add',
  'FpProjectList.footer.exists': '{0} Projects in total',
  'FpProjectList.footer.notFound': 'There is no project',
  'FpProjectSplitter.filter.hint': 'Filter by projects',
  'FpProjectTree.show-all': 'display all',
  'FpRole.delete.description': 'Please note that if you delete the file, it cannot be restored.',
  'FpRole.delete.title': 'Are you sure you want to delete it?',
  'FpRoleSelectGroup.button.all': 'All',
  'FpSearchCriteriaCard.delete-confirm.body': 'Search Criteria deletion is irreversible.',
  'FpSearchCriteriaCard.delete-confirm.title': 'Deleting Search Criteria',
  'FpSearchCriteriaCard.disabled.title': 'Copied Search Criteria from template cannot be edited.',
  'FpSearchCriteriaCard.layout-list': 'This search criteria are using in layout below.',
  'FpSearchCriteriaCard.not-in-use': 'Not in use.',
  'FpSearchCriteriaCard.unmodifiable-alert-dialog.body': 'Cannot be deleted this search criteria because there is a layout that refers to it. Please Edit the gadget and dereference it.',
  'FpSearchCriteriaCard.unmodifiable-alert-dialog.title': 'This Search Criteria is not deletable',
  'FpSearchCriteriaManagement.delete.error': 'An error occurred during the deletion process. Please try again.',
  'FpSearchCriteriaManagement.delete.success': 'The search criteria has been deleted',
  'FpSearchCriteriaManagement.filter.hint': 'Filtering by search criteria name',
  'FpSearchCriteriaManagement.no-criteria': 'There are no search criteria',
  'FpSearchCriteriaManagement.title': 'Serch Criteria Management',
  'FpSearchCriteriaManagement.title.description': 'Edit search criteria in this project.',
  'FpSearchCriteriaSave.dialog.title': 'Save As',
  'FpPortal.DownloadError': '{0} download failed.',
  'FpPortal.DownloadStatusError': '{0} is not available for download.',
  'gadgetContents.empty.label': 'There is no data',
  'gadgetContents.warning.label': 'Cannot be displayed while editing',
  'gadgetSelect.download.description': 'Files downloaded in the project',
  'gadgetSelect.download.label': 'Download History',
  'gadgetSelect.mainMenu.description': 'Shortcuts to folders and files necessary for work',
  'gadgetSelect.mainMenu.label': 'Main Menu',
  'gadgetSelect.myShortcut.description': 'Links to be added by individuals',
  'gadgetSelect.myShortcut.label': 'My Shortcuts',
  'gadgetSelect.newArrival.description': 'New Arrivals for files in the project',
  'gadgetSelect.newArrival.label': 'New Arrivals',
  'gadgetSelect.searchCriteria.description': 'Search results for saved search terms',
  'gadgetSelectGroup.label': 'Applicable Gadgets',
  'grid.noRecords': 'There is no data',
  'header.title': 'File Portal',
  'header.userInfo': 'You are logged in as {0}.',
  'label.access-level': 'Access Level',
  'label.add': 'Add',
  'label.approval_type': '承認区分',
  'label.back': 'back',
  'label.cancel': 'Cancel',
  'label.changing': 'Changing',
  'label.create_company_name': 'Created Company Name',
  'label.created-at': 'Created At',
  'label.creater': 'Created By',
  'label.data_item_count': 'Data Item Count',
  'label.delete': 'Delete',
  'label.details': 'Details',
  'label.edit': 'Edit',
  'label.file-name': 'File Name',
  'label.folder': 'Folder',
  'label.folder-name': 'Folder Name',
  'label.folder-search': 'Folder Search',
  'label.gadget-name': 'Gadget Name',
  'label.gadget-type': 'Gadget Typw',
  'label.gadget-type.GT1': 'MainMenu',
  'label.gadget-type.GT2': 'Original Search',
  'label.gadget-type.GT3': 'Download History',
  'label.gadget-type.GT4': 'New Arrival',
  'label.gadget-type.GT5': 'My Shortcut',
  'label.headquarters_role.change': 'Change Headquarters Roles',
  'label.headquarters_role.show': 'Show Headquarters Roles',
  'label.preview': 'Preview',
  'label.project_status.CLOSED': 'CLOSE',
  'label.project_status.DELETE': 'DELETE',
  'label.project_status.FROZEN': 'FROZEN',
  'label.project_status.OPEN': 'OPEN',
  'label.reload': 'Reload',
  'label.role': 'Role Name',
  'label.role-code': 'Role Code',
  'label.role-list': 'Role List',
  'label.role-name': 'Role Name',
  'label.save': 'Save',
  'label.download': 'Download',
  'label.mark_as_read': 'Mark As Read',
  'label.updated-at': 'Updated At',
  'label.updater': 'Updated By',
  'label.view': 'View',
  'layoutEdit.cancel.label': 'Cancel',
  'layoutEdit.changeRole.label': 'Change Project Roles',
  'layoutEdit.preview.back': 'Edit',
  'layoutEdit.preview.label': 'Preview',
  'layoutEdit.save.label': 'Save',
  'layoutEdit.warning.label': 'Editing the template layout',
  'layoutPreview.note': 'During preview display',
  'layoutRole.addLayout': 'Add layout',
  'layoutRole.addRole': 'Add new role',
  'layoutRole.copy': 'Copy to another project',
  'layoutRole.deleteLayout': 'Delete layout',
  'layoutRole.editLayout': 'Edit layout',
  'layoutRole.editName': 'Edit layout name',
  'layoutRole.unusedRole': 'Unused role',
  'link.attr': 'Extended Attribute Definition Management',
  'link.layout': 'Layout Management',
  'link.projectDetail': 'Project Details',
  'link.projectSwitch': 'Select Project',
  'link.search': 'Search Criteria Management',
  'link.top': 'Portal',
  logout: 'Logout',
  'mainMenuEditGridColumnProps.displayNameEn': 'Display Name (En)',
  'mainMenuEditGridColumnProps.displayNameJa': 'Display Name',
  'mainMenuEditGridColumnProps.type': 'Type',
  'mainMenuGrid.button.delete': 'Delete',
  'mainMenuGrid.button.edit': 'Edit',
  'mainMenuGrid.button.preview': 'Preview',
  'mainMenuItemTypeCode.type.MT1': 'Subheading',
  'mainMenuItemTypeCode.type.MT2': 'Text',
  'mainMenuItemTypeCode.type.MT3': 'URL',
  'mainMenuItemTypeCode.type.MT4': 'Search Criteria',
  'mainMenuItemTypeCode.type.MT5': 'Folder',
  'mainMenuItemTypeCode.type.MT6': 'File',
  'myshortcut.error.model': 'Return value not expected',
  'newArrivalNotification.content_tag_name': 'Folder Name',
  'newArrivalNotification.data_rack_name': 'File Name',
  'newArrivalNotification.notification_content': 'Notification Content',
  'newArrivalNotification.read': 'Already Read',
  'newArrivalNotification.source_user_name_without_middle_name': 'Update User Name',
  'newArrivalNotification.source_xgrab_user_company_name': 'Update Company Name',
  'newArrivalNotification.unread': 'Unread',
  'newArrivalNotification.updated_at': 'Updated At',
  'newArrivalNotification.loading': 'Loading...',
  'notification.extensiveAttributeDefinitionCreate.success': 'Your data have been saved',
  'notification.extensiveAttributeDefinitionUpdate.success': 'Your data have been saved',
  'notification.layoutCreate.success': 'Successfully registered the layout.',
  'notification.layoutDelete.success': 'Successfully deleted the layout.',
  'notification.layoutNameUpdate.success': 'Successfully updated the layout name.',
  'notification.layoutUpdate.error': 'Layout update failed: {0}',
  'notification.layoutUpdate.success': 'Updated the layout',
  'notification.putExtensiveAttributesAppliedContentTags.error': 'Applying Extensive-Attribute to Content-Tags failed.',
  'notification.putExtensiveAttributesAppliedContentTags.success': 'Applying Extensive-Attribute to Content-Tags succeed.',
  'notification.roleCreate.success': 'Successfully registered the role.',
  'notification.roleDelete.success': 'Successfully deleted the role.',
  'notification.download.waiting': 'Waiting',
  'page.description.extensiveAttribute': 'Edit extensive attribute in this project.',
  'page.description.layout-copy': 'Copy the Layout to selected destination.',
  'page.description.layoutRole': 'Manage the layout and roles of the project.',
  'page.description.mainMenuEditList': 'Edit the main menu used by {0}.',
  'page.description.projectSelect': 'Switch the display to the selected project.',
  'page.title.extensiveAttribute': 'ExtensiveAttribute Management',
  'page.title.layout-copy': 'Layout Copy',
  'page.title.layout-copy-preview': 'Layout Copy Preview',
  'page.title.layoutRole': 'Layout Management',
  'page.title.mainMenuEditList': 'Edit {0}',
  'page.title.projectSelect': 'Select Project',
  'project.list.title': 'Project List',
  'projectDetail.description': 'Details of the {0}.',
  'projectDetail.label.address': 'Address',
  'projectDetail.label.area': 'Area',
  'projectDetail.label.branchObjectName': 'Branch Name',
  'projectDetail.label.businessTypeName': 'Business Type Name',
  'projectDetail.label.constructionPlaceAddress': 'Construction Place Address',
  'projectDetail.label.endedOn': 'Ended On',
  'projectDetail.label.faxNumber': 'Fax Number',
  'projectDetail.label.ownerCompanyName': 'Owner Company Name',
  'projectDetail.label.ProjectGroupCompletedAt': 'Project Group Completed',
  'projectDetail.label.projectGroupName': 'Project Group Name',
  'projectDetail.label.projectGroupStatus': 'Project Group Status',
  'projectDetail.label.projectName': 'Project Name',
  'projectDetail.label.projectStatus': 'Project Status',
  'projectDetail.label.projectType': 'Project Type Name',
  'projectDetail.label.responsiblePersonName': 'Responsible Person Name',
  'projectDetail.label.startedOn': 'Started On',
  'projectDetail.label.telNumber': 'Tel Number',
  'projectDetail.title': 'Project Detail',
  'projectDetail.title.info': 'Project Infomation',
  'projectDetail.title.invitee': 'Project Member',
  'searchResult.contentTagName': 'Folder Name',
  'searchResult.dataItemCount': 'Data Item Count',
  'searchResult.rackName': 'File Name',
  'searchResult.sequenceNumber': 'Latest Version',
  'searchResult.updateCompanyName': 'Update Company Name',
  'searchResult.updatedAt': 'Updated At',
  'searchResult.updateUserName': 'Update User Name',
  'service.file': 'File',
  'service.picture': 'Photo',
  'service.title': 'File Portal',
  'service.pjInvite': 'Project Invitation',
  'service.groupManager': 'Group Manager',
  'service.spiderPlus': 'SPIDERPLUS LINK',
  'service.exchangeManager': 'Exchange Manager',
  'update.confirm.title': 'Update Confirmation',
  'validation.formatRegExp.message': 'must match the regular expression [{0}].',
  'validation.max.message': 'must be a string or array type with a maximum length of [{0}].',
  'validation.min.message': 'must be a string or array type with a minimum length of [{0}].',
  'validation.range.message': 'must be between {0} and {1}.',
  'validation.required.message': 'field is required.',
  'validation.uri.message': 'field is not a valid fully-qualified http, https, or ftp URL.',
  'validation.integer.message': 'must be a integer.',
  'notification.projectRead.warning': 'There are no projects invited.',
  'fileServiceLeftPaincontrolType.message': 'Open the folder list (left pane) when opening this link',
};
